import { createManifest } from '@/utils'
import { makeRequestCreator } from '@/api/common'
import store from '@/store'

const MainAPI = {
  /**
   * 상점을 구성하기 위한 기본 정보를 요청한다.
   * @param {string} shopId - 상점 이름
   * @param {Function} successCallback - 성공 시 호출할 콜백
   * @param {Function} errorCallback - 실패 시 호출할 콜백
   */
  getInitData: (shopId, successCallback = ()=>{}, errorCallback = ()=>{}) => {
    makeRequestCreator(
      'getInitData',
      {
        method: 'get',
        url: `/v2/main/initdata/${shopId}`
      },
      (responseData)=>{
        /* manifest 파일 생성  */
        const storeName = responseData.data.name
        if (window.Blob) {
          const stringManifest = JSON.stringify(createManifest(storeName, shopId));
          const blob = new Blob([stringManifest], {type: 'application/json'});
          const manifestURL = URL.createObjectURL(blob);
          document.querySelector('#manifest').setAttribute('href', manifestURL);
        }
        document.querySelector('title').innerHTML = storeName
        /* manifest 파일 생성 끝 */

        successCallback(responseData)
      },
      errorCallback
    )
  },
  /**
   * 상점의 home에 노출할 데이터를 요청한다.
   * @param {Function} successCallback - 성공 시 호출할 콜백
   * @param {Function} errorCallback - 실패 시 호출할 콜백
   */
  getHomeData: (successCallback = ()=>{}, errorCallback = ()=>{}) => {
    makeRequestCreator(
      'getHomeData',
      {
        method: 'get',
        url: `/v2/main/home/${store.getters['main/shopSeq']}`
      },
      successCallback,
      errorCallback
    )
  }
}

export default MainAPI
